"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referrerOptionButtonHeightForOptions = referrerOptionButtonHeightForOptions;
exports.referrerOptionButtonHeightForRows = referrerOptionButtonHeightForRows;
exports.referrerOptionGridRowCount = referrerOptionGridRowCount;
function referrerOptionGridRowCount(optionCount) {
  var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (optionCount <= 0) {
    return 1;
  }
  return Math.ceil(optionCount / columns);
}

/**
 * Equal height per row for a 2-column referrer grid, given the vertical space
 * available for all rows (gaps between rows are subtracted first).
 */
function referrerOptionButtonHeightForRows(_ref) {
  var gridContentHeightPx = _ref.gridContentHeightPx,
    rowCount = _ref.rowCount,
    _ref$rowGapPx = _ref.rowGapPx,
    rowGapPx = _ref$rowGapPx === void 0 ? 10 : _ref$rowGapPx,
    _ref$minHeightPx = _ref.minHeightPx,
    minHeightPx = _ref$minHeightPx === void 0 ? 72 : _ref$minHeightPx,
    _ref$maxHeightPx = _ref.maxHeightPx,
    maxHeightPx = _ref$maxHeightPx === void 0 ? 180 : _ref$maxHeightPx;
  if (rowCount < 1) {
    return minHeightPx;
  }
  var gapTotal = Math.max(0, rowCount - 1) * rowGapPx;
  var raw = (gridContentHeightPx - gapTotal) / rowCount;
  return Math.min(maxHeightPx, Math.max(minHeightPx, Math.floor(raw)));
}
function referrerOptionButtonHeightForOptions(_ref2) {
  var gridContentHeightPx = _ref2.gridContentHeightPx,
    optionCount = _ref2.optionCount,
    _ref2$columns = _ref2.columns,
    columns = _ref2$columns === void 0 ? 2 : _ref2$columns,
    _ref2$rowGapPx = _ref2.rowGapPx,
    rowGapPx = _ref2$rowGapPx === void 0 ? 10 : _ref2$rowGapPx,
    _ref2$minHeightPx = _ref2.minHeightPx,
    minHeightPx = _ref2$minHeightPx === void 0 ? 72 : _ref2$minHeightPx,
    _ref2$maxHeightPx = _ref2.maxHeightPx,
    maxHeightPx = _ref2$maxHeightPx === void 0 ? 180 : _ref2$maxHeightPx;
  var rows = referrerOptionGridRowCount(optionCount, columns);
  return referrerOptionButtonHeightForRows({
    gridContentHeightPx: gridContentHeightPx,
    rowCount: rows,
    rowGapPx: rowGapPx,
    minHeightPx: minHeightPx,
    maxHeightPx: maxHeightPx
  });
}